import React from 'react';
import { setVulnerabilityDetailTab } from 'store/Manage/actions';
import { selectVulnDetailSelectedTabContext } from 'store/Manage/selectors';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import TABS from './tabs';
import { TabSelectorWrapper, TabButton } from './styled';

const Tabs = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const selectedTab = useSelector(selectVulnDetailSelectedTabContext);

  const getLabel = (tab) => intl.formatMessage({ id: tab.intlId });
  const isActive = (tab) => tab.id === selectedTab.id;

  return (
    <TabSelectorWrapper>
      { TABS.map((tab) => (
        <TabButton
          active={ isActive(tab) }
          key={ tab.id }
          onClick={ () => dispatch(setVulnerabilityDetailTab(tab.id)) }
          children={ getLabel(tab) }
        />
      ))}
    </TabSelectorWrapper>
  );
};

export default Tabs;
